"use strict";
// Helpful resource on discriminated unions: https://css-tricks.com/typescript-discriminated-unions/
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradeWindDiagrams = exports.gradeWindDropZone = exports.gradeWindEquipment = exports.gradeSolarDCHealth = exports.gradeSolarHotspots = exports.gradeSolarEquipment = exports.gradeKnots = exports.gradeLoads = exports.gradeFraming = exports.gradeRopes = exports.gradeTopTie = exports.gradeDistributionEquipment = exports.isAdmin = exports.combineGradeMetrics = exports.getDefaultGradeMetrics = void 0;
const getDefaultGradeMetrics = () => {
    return {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
};
exports.getDefaultGradeMetrics = getDefaultGradeMetrics;
const combineGradeMetrics = (...metrics) => {
    const combinedMetrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    metrics.forEach((metric) => {
        combinedMetrics.technicalAvailable += metric.technicalAvailable;
        combinedMetrics.technicalEarned += metric.technicalEarned;
        combinedMetrics.safetyAvailable += metric.safetyAvailable;
        combinedMetrics.safetyEarned += metric.safetyEarned;
        combinedMetrics.employabilityAvailable += metric.employabilityAvailable;
        combinedMetrics.employabilityEarned += metric.employabilityEarned;
        combinedMetrics.hrGradingNotes.push(...metric.hrGradingNotes);
        combinedMetrics.jobsGradingNotes.push(...metric.jobsGradingNotes);
    });
    return combinedMetrics;
};
exports.combineGradeMetrics = combineGradeMetrics;
// =================
// Not strictly a type, but important to shared logic/permissions.
// NOTE: It looks like shared logic cannot be imported from outside the src directory due to react-create-app restrictions. I can across a suggestion to use https://docs.npmjs.com/cli/v7/configuring-npm/package-json#local-paths for local development (fine as long as the file is guaranteed to be at the same relative location, e.g. part of the same monorepo), which is something I may look into in the future.
const isAdmin = (emailAddress) => {
    return ["sam@powertechs.us", "sam@edapt.app"].includes(emailAddress);
};
exports.isAdmin = isAdmin;
const gradeDistributionEquipment = (profile) => {
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    // Proper Equipment
    ([["hammer", true], ["skinning knife", true], ["demolition screwdriver", true], ["cutting pliers", true], ["pump pliers", true], ["electrical tape", true]]).forEach(([label, active]) => {
        var _a, _b, _c;
        const matches = (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["equipment"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["instances"]) || []).filter((item) => { return item.name === label; });
        metrics.technicalAvailable += 1;
        metrics.technicalEarned += (active === ((_c = matches[0]) === null || _c === void 0 ? void 0 : _c.active)) ? 1 : 0;
    });
    ([["multimeter", false], ["inductor", false]]).forEach(([label, active]) => {
        var _a, _b, _c;
        const matches = (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["equipment"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["instances"]) || []).filter((item) => { return item.name === label; });
        metrics.technicalAvailable += 1;
        metrics.technicalEarned += (active === ((_c = matches[0]) === null || _c === void 0 ? void 0 : _c.active)) ? 1 : 0;
    });
    // Safe Equipment
    ([["hardhat", true], ["gloves", true]]).forEach(([label, active]) => {
        var _a, _b, _c;
        const matches = (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["equipment"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["instances"]) || []).filter((item) => { return item.name === label; });
        metrics.safetyAvailable += 1;
        metrics.safetyEarned += (active === ((_c = matches[0]) === null || _c === void 0 ? void 0 : _c.active)) ? 1 : 0;
    }); // ["sleeves", true], Sleeves are optional at APC (probably because most work is de-energized).
    ([["umbrella", false], ["vise grip", false], ["steel screwdriver", false]]).forEach(([label, active]) => {
        var _a, _b, _c;
        const matches = (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["equipment"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["instances"]) || []).filter((item) => { return item.name === label; });
        metrics.safetyAvailable += 1;
        metrics.safetyEarned += (active === ((_c = matches[0]) === null || _c === void 0 ? void 0 : _c.active)) ? 1 : 0;
    });
    return metrics;
};
exports.gradeDistributionEquipment = gradeDistributionEquipment;
const gradeTopTie = (profile) => {
    var _a;
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    const steps = (profile === null || profile === void 0 ? void 0 : profile["topTie"].state) || [];
    const targetAnswer = [
        "top",
        "button",
        "bottom",
        "button",
        "button",
        "button",
        "top",
        "button",
        "button",
        "fan out",
        "flatten"
    ];
    let matches132 = true;
    if (targetAnswer.length !== steps.length) {
        matches132 = false;
    }
    else {
        matches132 = targetAnswer.every((element, index) => {
            return (steps[index] === element);
        });
    }
    const weldError = (_a = profile === null || profile === void 0 ? void 0 : profile["topTie"].state) === null || _a === void 0 ? void 0 : _a.includes("weld");
    metrics.safetyAvailable += 1;
    metrics.safetyEarned += weldError ? 0 : 1;
    metrics.technicalAvailable += 1;
    metrics.technicalEarned += matches132 ? 1 : 0;
    // TODO: Softer scoring mechanism, grading notes.
    return metrics;
};
exports.gradeTopTie = gradeTopTie;
const gradeRopes = (profile) => {
    var _a, _b, _c, _d, _e, _f;
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    // const safeRopes = profile?.["ropes"].state?.handAboveWorker && profile?.["ropes"].state?.tagCorrectSide;
    metrics.safetyAvailable += 2;
    metrics.safetyEarned += ((_a = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _a === void 0 ? void 0 : _a.handAboveWorker) ? 1 : 0;
    metrics.safetyEarned += ((_b = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _b === void 0 ? void 0 : _b.tagCorrectSide) ? 1 : 0;
    // const usefulRopes = profile?.["ropes"].state?.handCorrectSide && profile?.["ropes"].state?.tagOnTransformer && profile?.["ropes"].state?.pulleyAboveWorker && profile?.["ropes"].state?.pulleyOnTransformer;
    metrics.technicalAvailable += 4;
    metrics.technicalEarned += ((_c = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _c === void 0 ? void 0 : _c.handCorrectSide) ? 1 : 0;
    metrics.technicalEarned += ((_d = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _d === void 0 ? void 0 : _d.tagOnTransformer) ? 1 : 0;
    metrics.technicalEarned += ((_e = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _e === void 0 ? void 0 : _e.pulleyAboveWorker) ? 1 : 0;
    metrics.technicalEarned += ((_f = profile === null || profile === void 0 ? void 0 : profile["ropes"].state) === null || _f === void 0 ? void 0 : _f.pulleyOnTransformer) ? 1 : 0;
    // TODO: Add grading notes.
    return metrics;
};
exports.gradeRopes = gradeRopes;
const gradeFraming = (profile) => {
    var _a, _b;
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    const holesList = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["framing"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.holesList) || [];
    metrics.technicalAvailable += 3;
    metrics.technicalEarned += holesList.length === 4 ? 1 : 0;
    // Got two holes for the crossarm
    metrics.technicalEarned += holesList.filter((fraction) => { return fraction < 1 && fraction > 36 / 40; }).length >= 2 ? 1 : 0;
    // Got two holes for the transformer
    metrics.technicalEarned += holesList.filter((fraction) => { return fraction < 36 / 40 && fraction > 1 / 2; }).length >= 2 ? 1 : 0;
    // TODO: Add grading notes.
    return metrics;
};
exports.gradeFraming = gradeFraming;
const gradeLoads = (profile) => {
    var _a, _b;
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    const selectedLoads = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["loads"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.selectedLoads) || {};
    metrics.safetyAvailable += 4;
    metrics.safetyEarned += ["1000PoundRope", "3000PoundRope", "6000PoundRope"].includes(selectedLoads["tagline"]) ? 1 : 0;
    metrics.safetyEarned += ["3000PoundRope", "6000PoundRope"].includes(selectedLoads["lifting"]) ? 1 : 0;
    metrics.safetyEarned += ["2000Pound3x3Block", "4000Pound4x4Block"].includes(selectedLoads["pulley"]) ? 1 : 0;
    metrics.safetyEarned += ["1900PoundGin", "3250PoundGin"].includes(selectedLoads["gin"]) ? 1 : 0;
    metrics.technicalAvailable += 4;
    metrics.technicalEarned += ["1000PoundRope", "3000PoundRope"].includes(selectedLoads["tagline"]) ? 1 : 0;
    metrics.technicalEarned += ["3000PoundRope"].includes(selectedLoads["lifting"]) ? 1 : 0;
    metrics.technicalEarned += ["2000Pound3x3Block"].includes(selectedLoads["pulley"]) ? 1 : 0;
    metrics.technicalEarned += ["1900PoundGin"].includes(selectedLoads["gin"]) ? 1 : 0;
    // TODO: Add grading notes.
    return metrics;
};
exports.gradeLoads = gradeLoads;
const gradeKnots = (profile) => {
    var _a, _b;
    const metrics = {
        technicalAvailable: 0,
        technicalEarned: 0,
        safetyAvailable: 0,
        safetyEarned: 0,
        employabilityAvailable: 0,
        employabilityEarned: 0,
        hrGradingNotes: [],
        jobsGradingNotes: [],
    };
    const selectedKnots = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["knots"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.selectedKnots) || {};
    metrics.technicalAvailable += 2;
    metrics.technicalEarned += "square" === selectedKnots["top"] ? 1 : 0;
    metrics.technicalEarned += "tautline" === selectedKnots["tag"] ? 1 : 0;
    // TODO: Add grading notes.
    return metrics;
};
exports.gradeKnots = gradeKnots;
const gradeLabels = (labels, instances) => {
    const total = labels.length;
    let count = 0;
    labels.forEach(([label, targetValue]) => {
        const matches = instances.filter((item) => { return item.name === label; });
        if (matches.length >= 1) {
            count += (matches[0].active === targetValue ? 1 : 0);
        }
        else {
            count += 1;
        }
    });
    return [count, total];
};
const gradeSolarEquipment = (profile) => {
    var _a, _b;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    const equipment = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["solarEquipment"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.instances) || [];
    const gradingNote = {
        skillName: "Solar Equipment",
        comments: [],
    };
    // Grade for necessary tools
    const necessaryTools = [
        ["multifunctionTool", true],
        ["electricalTape", true],
    ];
    let [earned, available] = gradeLabels(necessaryTools, equipment);
    metrics.technicalAvailable += available;
    metrics.technicalEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Missing essential tools + equipment.", commentType: "competence", status: "warning" });
    }
    // Grade for unnecessary tools
    const unnecessaryTools = [
        ["umbrella", false],
        ["wire", false],
    ];
    [earned, available] = gradeLabels(unnecessaryTools, equipment);
    metrics.technicalAvailable += available;
    metrics.technicalEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Brought irrelevant equipment.", commentType: "competence", status: "warning" });
    }
    // Grade for safety equipment
    const safetyEquipment = [
        ["gloves", true],
    ];
    [earned, available] = gradeLabels(safetyEquipment, equipment);
    metrics.safetyAvailable += available;
    metrics.safetyEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Missing essential safety equipment.", commentType: "safety", status: "danger" });
    }
    // Check for unsafe equipment
    const unsafeEquipment = [
        ["vise grip", false],
        ["steel screwdriver", false],
    ];
    [earned, available] = gradeLabels(unsafeEquipment, equipment);
    metrics.safetyAvailable += available;
    metrics.safetyEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Brought unsafe equipment.", commentType: "safety", status: "danger" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeSolarEquipment = gradeSolarEquipment;
const gradeSolarHotspots = (profile) => {
    var _a, _b, _c, _d, _e, _f;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    const gradingNote = {
        skillName: "Solar Panel Inspection",
        comments: [],
    };
    // x = .7, y = .8
    metrics.technicalAvailable += 1;
    if (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["solarHotspots"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["identifiedCause"]) === "hotspot") {
        metrics.technicalEarned += 1;
        gradingNote.comments.push({ comment: "Correctly identified panel flaw.", commentType: "competence", status: "success" });
    }
    else {
        gradingNote.comments.push({ comment: "Misidentified panel flaw.", commentType: "competence", status: "warning" });
    }
    const xCoord = ((_d = (_c = profile === null || profile === void 0 ? void 0 : profile["solarHotspots"]) === null || _c === void 0 ? void 0 : _c["state"]) === null || _d === void 0 ? void 0 : _d["highlightX"]) || 0;
    const yCoord = ((_f = (_e = profile === null || profile === void 0 ? void 0 : profile["solarHotspots"]) === null || _e === void 0 ? void 0 : _e["state"]) === null || _f === void 0 ? void 0 : _f["highlightY"]) || 0;
    const squaredError = Math.pow(xCoord - .7, 2) + Math.pow(yCoord - .8, 2);
    metrics.technicalAvailable += 1;
    if (squaredError < .04) {
        metrics.technicalEarned += 1;
        gradingNote.comments.push({ comment: "Correctly isolated panel damage.", commentType: "competence", status: "success" });
    }
    else {
        gradingNote.comments.push({ comment: "Imperfectly located panel damage.", commentType: "competence", status: "warning" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeSolarHotspots = gradeSolarHotspots;
const gradeSolarDCHealth = (profile) => {
    var _a, _b;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    // TODO: Add other checks based on trajectory of measurements.
    const gradingNote = {
        skillName: "Solar Plant DC Health",
        comments: [],
    };
    metrics.technicalAvailable += 1;
    if (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["solarDCHealth"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["identifiedCause"]) === "centerMiswired") {
        metrics.technicalEarned += 1;
        gradingNote.comments.push({ comment: "Correctly identified issue.", commentType: "competence", status: "success" });
    }
    else {
        gradingNote.comments.push({ comment: "Misidentified issue.", commentType: "competence", status: "warning" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeSolarDCHealth = gradeSolarDCHealth;
const gradeWindEquipment = (profile) => {
    var _a, _b;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    const gradingNote = {
        skillName: "Wind Technician Equipment Selection",
        comments: [],
    };
    const equipment = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["windEquipment"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.instances) || [];
    // Grade for necessary tools
    const necessaryTools = [
        ["liftingBag", true],
        ["headlamp", true],
    ];
    let [earned, available] = gradeLabels(necessaryTools, equipment);
    metrics.technicalAvailable += available;
    metrics.technicalEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Missing essential tools + equipment.", commentType: "competence", status: "warning" });
    }
    // Grade for unnecessary tools
    const unnecessaryTools = [
        ["umbrella", false],
        ["wire", false],
    ];
    [earned, available] = gradeLabels(unnecessaryTools, equipment);
    metrics.technicalAvailable += available;
    metrics.technicalEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Brought irrelevant equipment.", commentType: "competence", status: "warning" });
    }
    // Grade for safety equipment
    const safetyEquipment = [
        ["gloves", true],
        ["vest", true],
        ["hardhat", true],
        ["radio", true]
    ];
    [earned, available] = gradeLabels(safetyEquipment, equipment);
    metrics.safetyAvailable += available;
    metrics.safetyEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Missing essential safety equipment.", commentType: "safety", status: "danger" });
    }
    // Check for unsafe equipment
    const unsafeEquipment = [];
    [earned, available] = gradeLabels(unsafeEquipment, equipment);
    metrics.safetyAvailable += available;
    metrics.safetyEarned += earned;
    if (earned !== available) {
        gradingNote.comments.push({ comment: "Brought unsafe equipment.", commentType: "safety", status: "danger" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeWindEquipment = gradeWindEquipment;
const gradeWindDropZone = (profile) => {
    var _a, _b;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    const gradingNote = {
        skillName: "Wind Turbine Lifting Safety",
        comments: [],
    };
    const dropRadiusUnits = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["windDropZone"]) === null || _a === void 0 ? void 0 : _a["state"]) === null || _b === void 0 ? void 0 : _b["dropRadiusUnits"]) || 0;
    metrics.technicalAvailable += 1;
    metrics.safetyAvailable += 1;
    if (dropRadiusUnits < 10) {
        gradingNote.comments.push({ comment: "Underestimated Drop Zone.", commentType: "safety", status: "danger" });
    }
    else if (dropRadiusUnits > 100) {
        metrics.safetyEarned += 1;
        gradingNote.comments.push({ comment: "Cumbersome Drop Zone Estimation.", commentType: "competence", status: "warning" });
    }
    else {
        metrics.safetyEarned += 1;
        metrics.technicalEarned += 1;
        gradingNote.comments.push({ comment: "Correct Drop Zone Estimation.", commentType: "competence", status: "success" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeWindDropZone = gradeWindDropZone;
const gradeWindDiagrams = (profile) => {
    var _a, _b;
    const metrics = (0, exports.getDefaultGradeMetrics)();
    const gradingNote = {
        skillName: "Wind Turbine Maintenance",
        comments: [],
    };
    const selections = ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile["windDiagrams"]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.selections) || {};
    metrics.technicalAvailable += 1;
    if ("hydraulicBladeBlock" === selections["diagram"]) {
        metrics.technicalEarned += 1;
        gradingNote.comments.push({ comment: "Identified Correct Diagram.", commentType: "competence", status: "success" });
    }
    else {
        gradingNote.comments.push({ comment: "Misidentified Correct Diagram.", commentType: "competence", status: "warning" });
    }
    if (gradingNote.comments.length > 0) {
        metrics.hrGradingNotes.push(gradingNote);
        metrics.jobsGradingNotes.push(gradingNote);
    }
    return metrics;
};
exports.gradeWindDiagrams = gradeWindDiagrams;
